var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.04545 3L13.5 3M13.5 3L13.5 9.45455M13.5 3L3.5 13","stroke":"#211752","stroke-width":"2","stroke-linecap":"square"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/ExternalLink.vue